<ng-container *ngrxLet="packingListResource$ as packingListResource">
  <div class="erow" [class.last]="isLast" *ngIf="item">
    <div class="etext">
      <div class="item">
        <i
          class="ifc-custom ifc-chevron_down collapse-icon"
          [class.collapsed]="collapsed"
          (click)="collapsed = !collapsed"
        ></i>
        <img
          class="eimage"
          src="/img/ClosureImages/Overpack.png"
          alt="OverPacking"
        />
        <label>{{ item | calculatedName: packingListResource }}</label>
        <span class="ch-ggs-web-suite-packing-cmds ml-auto">
          <button
            type="button"
            class="btn"
            (click)="edit()"
            [title]="packingListResource['EditPackage']"
          >
            <i
              class="ifc-custom ifc-pencil d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="btn"
            (click)="copyPackage()"
            [title]="packingListResource['CopyPackage']"
          >
            <i
              class="ifc-custom ifc-content_copy d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="btn"
            (click)="removePackage()"
            [title]="packingListResource['RemoveDangerousGoodButton']"
          >
            <i
              class="ifc-custom ifc-bin d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
        </span>
      </div>
    </div>
    <div class="inner-packagings" [class.collapsed]="collapsed">
      <lib-easydgd-composite-packaging-item
        [item]="item"
        [isLast]="last && !singlePackagingItems.length"
        [showPrintLabel]="showPrintLabel"
        (editPackage)="editCompositePackage.emit($event)"
        (removeCompositePackage)="removeCompositePackage.emit(item)"
        (duplicateCompositePackage)="duplicateCompositePackage.emit($event)"
        *ngFor="let item of compositePackagingItems; let last = last"
      ></lib-easydgd-composite-packaging-item>
      <lib-easydgd-single-packaging-item
        [item]="item"
        [isLast]="last"
        [showPrintLabel]="showPrintLabel"
        (editPackage)="editSinglePackage.emit($event)"
        (removePackage)="removeSinglePackage.emit(item)"
        (copyPackage)="duplicateSinglePackage.emit($event)"
        *ngFor="let item of singlePackagingItems; let last = last"
      ></lib-easydgd-single-packaging-item>
    </div>
  </div>

  <lib-easydgd-overpack-modal
    [isEdit]="true"
    [show]="showOverpackModal"
    [package]="item"
    [overpackItems]="overPackagingItems"
    [overpackTitle]="packingListResource['OverPackModalTitle']"
    (closeOverpackModal)="closeOverpackageModal($event)"
  ></lib-easydgd-overpack-modal>
</ng-container>
